<template>
  <div class="container">
    <div class="mt-5 mb-3 text-center">
      <h3 class="mb-3">Service</h3>
      <BootstrapIcon
        class="add-btn primary"
        icon="plus-circle"
        @click="showModal"
      />
    </div>
    <table class="table table-hover table-striped table-bordered align-middle">
      <caption>
        Service Information
      </caption>
      <thead>
        <tr>
          <th scope="col">Preview</th>
          <th scope="col">Title EN</th>
          <th scope="col">Title CH</th>
          <th scope="col">Description EN</th>
          <th scope="col">Description CH</th>
          <th scope="col">Option</th>
        </tr>
      </thead>
      <tbody>
        <tr :key="service._id" v-for="service in data">
          <AdminServiceTable :service="service" />
        </tr>
      </tbody>
    </table>

    <ModalService v-if="displayModal" @close-modal-service="hideModal" />
  </div>
</template>
<script>
import axios from "axios";
import ModalService from "./ModalService.vue";
import AdminServiceTable from "./AdminServiceTable.vue";
export default {
  name: "AdminService",
  components: {
    ModalService,
    AdminServiceTable,
  },
  data() {
    return {
      displayModal: false,
      data: null,
    };
  },
  methods: {
    showModal() {
      this.displayModal = true;
    },
    hideModal() {
      this.displayModal = false;
    },
  },
  created() {
    axios
      .get(this.$webDomain + "/gardenInit/GardenService")
      .then((response) => (this.data = response.data.data));
  },
};
</script>
